import classNames from "classnames";
import { TooltipWrapper } from "../../../components/tooltip/TooltipWrapper";
import styles from "./ReadyToIssueStamp.module.css";

// Tilted seal shown on accounts the backend flags as ready_for_issuance.
export const ReadyToIssueStamp = () => {
  return (
    <TooltipWrapper tooltipText="Ready to issue — bound, with SL letter and final manuscript form or lead policy on file">
      <i className={classNames("pi pi-verified", styles.seal)} />
    </TooltipWrapper>
  );
};
